import * as React from 'react';

export function Home() {
  return (
    <div>
      <p>There&apos;s no place like home.</p>
    </div>
  );
}
